import { defaultTenantId } from '@/units/config';

export function cartActivityHintKey(tenantId, goodsId, skuPriceId) {
  const tid = tenantId || defaultTenantId || '';
  return `mall_cart_act_${tid}_${goodsId}_${skuPriceId}`;
}

/** 从秒杀/活动详情加购时写入，用于购物车页在无 activity_id 落库时触发一次 cover 重算 */
export function setCartActivityHint(tenantId, goodsId, skuPriceId, activityId) {
  if (!goodsId || !skuPriceId || !activityId) return;
  try {
    sessionStorage.setItem(cartActivityHintKey(tenantId, goodsId, skuPriceId), String(activityId));
  } catch (e) {
    /* ignore */
  }
}

export function getCartActivityHint(tenantId, goodsId, skuPriceId) {
  try {
    return sessionStorage.getItem(cartActivityHintKey(tenantId, goodsId, skuPriceId));
  } catch (e) {
    return null;
  }
}

export function clearCartActivityHint(tenantId, goodsId, skuPriceId) {
  try {
    sessionStorage.removeItem(cartActivityHintKey(tenantId, goodsId, skuPriceId));
  } catch (e) {
    /* ignore */
  }
}
